module.exports = __webpack_public_path__ + "static/media/loopBg.393febce.mp4";